/* eslint-disable */
export default {
  cancel: 'Annuleren',
  reply: 'Beantwoorden',
  onMyWay: 'Onderweg',
  customMessage: 'Aangepast bericht',
  callMeBackIn: 'Bel me terug over',
  willCallYouBackIn: 'Ik bel u terug over',
  min: 'min.',
  hours: 'uur',
  days: 'dagen',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
